import useIsMobile from '@/hooks/useIsMobile';
import VoucherModalDesktop from './desktop';
import VoucherModalMobile from './mobile';
import useVoucherModal from './useVoucherModal';

const VoucherModal = (props) => {
  const isMobile = useIsMobile(992);
  const viewModel = useVoucherModal(props);

  if (isMobile) {
    return <VoucherModalMobile viewModel={viewModel} />;
  }

  return <VoucherModalDesktop viewModel={viewModel} />;
};

export default VoucherModal;